module.exports = "<h1 class=\"text-center\">Notices</h1>\n\n<div class=\"panel panel-default m-t-lg p-md\"\n     ng-repeat=\"notice in notices\"\n>\n\t<div ng-bind-html=\"parseMarkdown(notice.body)\"></div>\n\n\t<div class=\"text-right\">\n\t\t<button type=\"button\"\n\t\t        class=\"btn btn-primary\"\n\t\t        ng-click=\"markViewed(notice.id)\"\n\t\t>\n\t\t\tMark as Viewed\n\t\t</button>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/endpoints/auth/viewNotices/view.html
// module id = 1020
// module chunks = 0